import * as React from "react";

const SvgClose = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M2.41147 16.6889L16.8009 2L18 3.22408L3.61059 17.913L2.41147 16.6889Z" fill="currentColor" /><path fillRule="evenodd" clipRule="evenodd" d="M16.3894 18L2 3.31107L3.19912 2.08699L17.5885 16.7759L16.3894 18Z" fill="currentColor" /></svg>;

export default SvgClose;